import React from "react"
// import PropTypes from "prop-types"
import GetImage from '../components/Image'
import Layout from "../components/layout"
import Form from "../components/Form"
const propTypes = {}

const defaultProps = {}

export default class ContactPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <Layout>
        <div className="page-wrapper">
          <div className="fullscreen-50 bg3" data-scroll-index="0">
            <div className="grediant-overlay opacity-6"></div>
            <div className="center-col text-center white-text" id="home">
              <div className="container-fluid">
                <div className="row">
                  <div
                    className="col-md-10 col-lg-8 mx-auto"
                    data-aos="fade-up"
                    data-aos-duration="600"
                    data-aos-delay="500"
                  >
                    <div className="home-content">
                      <h1 className="large-heading">
                        <span className="font-weight-extralight">Contact Us</span>{" "}
                        <br />
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section
            className="contact-us-form theme-1 section-spacer"
            data-scroll-index="0"
          >
            <div className="container">
              <div className="section-header">
                <h2>Get in touch</h2>
              </div>
              <Form />
            </div>
          </section>

          <section className="contact-us bg-light" data-scroll-index="0">
            <div className="container-fluid">
              <div className="row align-items-stretch">
                <div
                  className="col-md-6 p-0"
                  data-aos="fade"
                  data-aos-duration="400"
                >
                  <div className="address-container bg2 h-100">
                    <div className="grediant-overlay-reverse opacity-85"></div>
                    <div className="address-content">
                      <div className="address-info">
                        <h2>
                          Unit No 214, Good Earth City Center Mall, Sector 50,
                          <br />
                          Gurgaon, 122018, Haryana
                        </h2>
                      </div>
                      <div className="address-info">
                        <a
                          title="call +919910580555"
                          className="contact-link"
                          href="tel:+919910580555"
                        >
                          +91 991 058 0555
                        </a>
                      </div>
                      <div className="address-info">
                        <a
                          title="Mail to support@meegrow.com"
                          className="contact-link "
                          href="mailto:support@meegrow.com"
                        >
                          support@meegrow.com
                        </a>
                      </div>
                      {/* <div className="social-link social-white">
                        <a href="#" className="ln">
                          <i className="fa fa-linkedin"></i>
                        </a>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-6 p-0">
                  <div className="section">
                    <a href="https://www.google.com" target="_blank" rel="noopener noreferrer" >
                    <GetImage filename="map.png" alt="map" />
                      <div className="middle">
                        <div className="btn btn-primary btn-rounded">
                          Get Direction Here
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </Layout>
    )
  }
}

ContactPage.propTypes = propTypes
ContactPage.defaultProps = defaultProps
